<template>
  <el-container class="home-wrap">
    <el-main class="full-content buy-table buy-table-setapp">
      <div class="setapp_time_limit">{{$t('Set app time limit')}}</div>
      <el-tabs v-loading="isloading" class="flex-col-start buy-header" v-model="activeName" type="card" @tab-click="handleClick">
         <el-tab-pane label="Blocked" name="first" class="tab-pane-btn">
           <div class="flex-col-center buy-main">
             <div class="buy-main-y">
               <div v-for="(item, i) in setAppDatasblack" :key="i" class="setapp-mian">
                 <div class="setapp-mian-div">
                   <div class="app-main-note flex-row-center-start">
                     <img style="width:48px;height:48px" :src="item.img" alt="">
                     <span>{{item.name}}</span>
                   </div>
                   <el-switch
                     v-if="setAppDatasblack && setAppDatasblack.length > 0"
                     v-model="item.switchBlackValue"
                     active-color="#2bcf88"
                     :width="50"
                     @change="ValueBlackChange(item)"
                     inactive-color="#888">
                   </el-switch>
                 </div>
               </div>
             </div>
           </div>
        </el-tab-pane>
         <el-tab-pane label="Exceptional" name="second" class="tab-pane-btn">
           <div class="flex-col-center buy-main">
             <div class="buy-main-y">
               <div v-for="(item, i) in setAppDatasWhite" :key="i" class="setapp-mian">
                 <div class="setapp-mian-div">
                   <div class="app-main-note flex-row-center-start">
                     <img style="width:48px;height:48px" :src="item.img" alt="">
                     <span>{{item.name}}</span>
                   </div>
                   <el-switch
                    v-if="setAppDatasWhite && setAppDatasWhite.length > 0"
                     v-model="item.switchValue"
                     active-color="#2bcf88"
                     :width="50"
                     @change="ValueChange(item)"
                     inactive-color="#888">
                   </el-switch>
                 </div>
               </div>
             </div>
           </div>
        </el-tab-pane>
      </el-tabs>
      <div class="flex-row-center buy-footer">
        <el-button @click="onCancelApp" class="normalBtn buy-footer-btn">{{$t('Return')}}
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: 'set-exception-app',
  props: ['userid', 'device'],
  data () {
    return {
      activeName: 'first',
      isloading: false,
      setAppDatasblack: [],
      setAppDatasWhite: [],
      AppDatas: null,
      blackDatas: [],
      getBlackList: null,
      getWhiteList: null,
      lastItmeDatas: null
    }
  },
  methods: {
    async getScreenAppLimit () {
      try {
        // 获取所有APP
        this.isloading = true
        const datas = await this.$http.get(`MDM/Applications?id${this.$route.params.device}`)
        this.AppDatas = datas.data.data
        // console.log(this.AppDatas)
        this.blackDatas = []
        this.AppDatas.map((c) => {
          this.blackDatas.push(c.title)
        })
        console.log(this.blackDatas)
        // 查询是否设置过白名单 是否有白名单id
        const getDatas = await this.$http.get('MDM/ScheduleRestriction')
        let getBlack = getDatas.data.data
        let getList = getBlack.filter(c => c.title === 'AppWhiteList')
        console.log(getList)
        // 如果没有设置过黑白名单获取的为空，就需要把黑名单都设置。  有设置过就直接调黑白名单显示到页面
        if (getList.length === 0) {
          console.log(this.blackDatas)
          const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
            params: {
              name: 'AppWhiteList'
            }
          })
          let parmas = {
            blacklist: this.blackDatas,
            id: Number(datas.data.id)
          }
          let formBody = new FormData()
          formBody.append('name', 'AppWhiteList')
          formBody.append('id', Number(datas.data.id))
          formBody.append('data', JSON.stringify(parmas))
          const setblackDatas = await this.$http.post(`MDM/SetScheduleAppList`, formBody)
          console.log(setblackDatas)
          this.getScreenAppLimit()
        } else {
          let lastList = getList.length - 1
          this.lastItmeDatas = getList[lastList]
          console.log(this.lastItmeDatas)
          this.getBlackList = this.lastItmeDatas.blackList
          this.getWhiteList = this.lastItmeDatas.whiteList
          console.log(this.getBlackList, this.getWhiteList)
          // 获取的黑名单
          this.setAppDatasblack = []
          for (let i = 0; i < this.getBlackList.length; i++) {
            let obj = {}
            obj.name = this.getBlackList[i]
            obj.img = `${this.STS_URL}` + '/' + obj.name + '.png'
            obj.switchBlackValue = false
            this.setAppDatasblack.push(obj)
          }
          // 获取的白名单
          this.setAppDatasWhite = []
          for (let i = 0; i < this.getWhiteList.length; i++) {
            let objs = {}
            objs.name = this.getWhiteList[i]
            objs.img = `${this.STS_URL}` + '/' + objs.name + '.png'
            objs.switchValue = true
            this.setAppDatasWhite.push(objs)
          }
        }
        this.isloading = false
      } catch (e) {
        console.log(e)
      }
    },
    // 黑名单切换
    async ValueBlackChange (e) {
      console.log(e, this.setAppDatasblack, this.getWhiteList)
      if (e.switchBlackValue === true) {
        this.setAppDatasblack = this.setAppDatasblack.filter(c => c.name !== e.name)
        // 黑名单
        let blacks = []
        this.setAppDatasblack.map((c) => {
          blacks.push(c.name)
        })
        // 设置白名单
        this.getWhiteList.push(e.name)
        let parmas = {
          blacklist: blacks,
          id: Number(this.lastItmeDatas.id),
          whitelist: this.getWhiteList
        }
        let formBody = new FormData()
        formBody.append('name', 'AppWhiteList')
        formBody.append('id', Number(this.lastItmeDatas.id))
        formBody.append('data', JSON.stringify(parmas))
        const ScheduleDatas = await this.$http.post('MDM/SetScheduleAppList', formBody)
        console.log(ScheduleDatas)
        this.getScreenAppLimit()
      }
    },
    // 白名单切换
    async ValueChange (e) {
      console.log(e, this.lastItmeDatas, this.getBlackList)
      if (e.switchValue === false) {
        this.setAppDatasWhite = this.setAppDatasWhite.filter(c => c.name !== e.name)
        // 黑名单
        let whites = []
        this.setAppDatasWhite.map((c) => {
          whites.push(c.name)
        })
        // 设置白名单
        this.getBlackList.push(e.name)
        let parmas = {
          blacklist: this.getBlackList,
          id: Number(this.lastItmeDatas.id),
          whitelist: whites
        }
        let formBody = new FormData()
        formBody.append('name', 'AppWhiteList')
        formBody.append('id', Number(this.lastItmeDatas.id))
        formBody.append('data', JSON.stringify(parmas))
        const ScheduleDatas = await this.$http.post('MDM/SetScheduleAppList', formBody)
        console.log(ScheduleDatas)
        this.getScreenAppLimit()
      }
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    onCancelApp () {
      this.$emit('onCancelApp', true)
    }
  },
  mounted () {
    this.getScreenAppLimit()
  }
}
</script>

<style lang="scss" scoped>
.home-wrap{
  width:100%;
  height:100%;
  box-sizing: border-box;
  overflow: hidden;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 100%;
    overflow: hidden;
    .buy-header{
      width:100%;
      height:77%;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      color: #333333;
      font-size: 24px;
    }
    .buy-main{
      width: 100%;
      height: 100%;
      .nodata-found{
        font-size: 18px;font-weight: normal;line-height: 54px;color: #777777;margin-top: 20px;
      }
      .buy-main-y{
        overflow-y:scroll;width: 100%;height: 100%;
        .setapp-mian {
          padding-left: 3%;
          padding-right: 3%;
          .setapp-mian-div {
            padding-bottom: 1%;
            padding-top: 1%;
            padding-right: 2%;
            border-bottom: 1px solid #e7e7e7;
            display: -moz-box;  /* Firefox */
          display: -ms-flexbox;/* IE10 */
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;
          }
          .setapp-mian-div:hover {
            background-color: #f1faf7;
          }
        }
      }
    }
  }
}
.main-setapp{
  padding-left: 3%;
  padding-right: 5%;
}
.buy-footer{
  width:100%;
  height:9%;
  // border-top:1px solid #e5e5e5;
  padding:15px 0;
  .buy-footer-btn{
    height:48px;
    width:180px !important;
    font-size:20px;
 }
}
.tab-pane-btn {
  height: 100%;
}
.setapp_time_limit{
  font-size: 24px;
  color: #333333;
  padding: 2% 0;
}
.app-main-note span {
  font-size: 18px;color: #333333;padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/SetExceptionApp.vue